// src/pages/Home.tsx
import React from 'react';
import { Link } from 'react-router-dom';

import SEO from "../components/SEO";
import { seoConfig } from "../seoConfig";


import ServiceSection from '../components/ServiceSection';
import GetInTouch from '../components/GetInTouch';
import TestimonialSection from '../components/TestimonialSection';


import { useScrollDownCircle } from '../hooks/useScrollDownCircle';
import { useJumpAnimation } from '../hooks/useJumpAnimation';


import { useGsapImageReveal } from "../hooks/useGsapImageReveal";



// Banner Video link
import bannerVideo from '../assets/images/video/03.mp4';

import about1 from '../assets/images/about/07.png';
import about2 from '../assets/images/faq/01.png';





const Home: React.FC = () => {


  const seo = seoConfig.home; // ✅ Load meta for this page



  useScrollDownCircle([
    {
      targetClass: 'scroll-down-circle-3',
      triggerClass: 'rts-scroll-down-circle-wrapper-3',
      y: -300,
      start: 'top 25%',
      end: '30% top',
      duration: 15,
    },
    {
      targetClass: 'scroll-down-circle-4',
      triggerClass: 'rts-scroll-down-circle-wrapper-4',
      x: -300,
      start: 'top 80%',
      end: '30% top',
      duration: 15,
    },
    {
      targetClass: 'scroll-down-circle-5',
      triggerClass: 'rts-scroll-down-circle-wrapper-5',
      y: -300,
      start: 'top 80%',
      end: '20% top',
      duration: 15,
    },
    {
      targetClass: 'scroll-right-box-banner',
      triggerClass: 'scroll-right-box-banner-wrapepr',
      x: 300,
      start: 'top 80%',
      end: '30% top',
      duration: 15,
    },
  ]);

  useJumpAnimation({
    triggerSelector: '.counter_animation',
    itemSelector: '.counter_animation .counter__anim',
  });

  useJumpAnimation({
    triggerSelector: '.bannerJump_animation',
    itemSelector: '.bannerJump_animation .jump__anim',
  });


useGsapImageReveal("one");
useGsapImageReveal("two");
useGsapImageReveal("three");
useGsapImageReveal("toBottom");



  return (

<>


      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
        image={seo.image}
      />

{/* Banner Area Start */}
<div className="banner-area banner-style-one hero__area-3 banner__jump video-banner">
  {/* Background Video */}
  <video
    className="banner-video"
    autoPlay
    loop
    muted
    playsInline
  >
    <source src={bannerVideo} type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Gradient Overlay */}
  <div className="video-overlay"></div>

  {/* Content */}
  <div className="top-center-image rts-scroll-down-circle-wrapper-3 d-none d-md-block">
    <a href="mailto:info@manikarndigital.com" className="speen-shape scroll-down-circle-3">
      <svg
        className="uni-circle-text-path uk-text-secondary uni-animation-spin"
        viewBox="0 0 100 100"
        width={180}
        height={180}
      >
        <defs>
          <path
            id="circle"
            d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
          ></path>
        </defs>
        <text fontSize="11">
          <textPath xlinkHref="#circle">
            MANIKARN DIGITAL • MANIKARN DIGITAL •
          </textPath>
        </text>
      </svg>
      <i className="fa fa-envelope icn-size28" style={{ color: 'var(--primary-color)' }}></i>
    </a>
  </div>

  <div className="container">
    <div className="row ptb--200 ptb_sm--140">
      <div className="col-lg-9">
        <div className="banner-one-wrapper">
          <h1 className="title rts_hero__title">
            Driving Results <br />
            with{" "}
            <span className="border-bottom-1">MANIKARN DIGITAL</span> <br />
            Solutions
          </h1>
          <div className="para-wraph d-none d-md-block">
            <p className="disc hero__sub-title">
              Our team of experts is dedicated to helping you achieve <br />
              your digital goals. From website design and development <br />
              to SEO, PPC advertising, and social media marketing.
            </p>
          </div>
          <div className="bannerJump_animation banner-jump-button rts-scroll-down-circle-wrapper-4 d-none d-md-block">
            <div className="jump__anim rts_round_btn_wrap scroll-down-circle-4">
              <div className="rts-mouse-move-button">
                <div className="btn_wrapper">
                  <Link to="/services"
                    className="rts-btn-mouse-move btn-hover btn-item text-center"
                  >
                    <span /> Explore Our <br />
                    Services
                    <i className="fa-solid fa-arrow-up-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
{/* Banner Area End */}



  {/* rts faq area start */}
  <div className="rts-faq-style-two pt_sm--0 pb--40">
    <div className="container pt--120">
      <div className="row g-5 pl--70 pl_md--15 pl_sm--0 pt_md--50 pt_sm--50 align-items-lg-center">
        <div className="col-lg-5 d-none d-md-block">
          <div className="faq-thumbnail-two">
            <div className="main-img  rts-reveal-one">
              <img
                className="main rts-reveal-image-one"
                src={about1}
                alt="faq_area"
              />
            </div>
            <div className="small-img rts-reveal-three">
              <img
                className="rts-reveal-image-three"
                src={about2}
                alt="faq"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-7 rts-slide-left-gsap">


<div className="content-wrapper">
  <span className="sub-title">MANIKARN DIGITAL</span>
  <h2 className="title mt--15 mb--20 mt_sm--10 mb_sm--10">
    Transform Your Digital Presence
  </h2>
  <p className="disc">
    At Manikarn Digital, we empower your business with innovative marketing strategies and creative digital solutions. Our expert team transforms ideas into success, ensuring your brand not only stands out but truly shines. We harness cutting-edge techniques to engage your audience and drive measurable results. With our passion for challenging conventional thinking and pushing creative boundaries, your brand is set for extraordinary growth. Let’s connect and create digital magic together.
  </p>
  <Link to="/about" className="learn-more-btn mt--30 mt_sm--10">
    More Details <i className="fa-solid fa-arrow-up-right-from-square"></i>
  </Link>
</div>

          



        </div>
      </div>
    </div>
  </div>
  {/* rts faq area end */}




  {/* large-image sections starts */}
  <div className="large-image-option-start position-relative rts_jump_counter__animation">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          {/* cunter up main wrapper */}
          <div className="counter-up-wrapper counter_animation">
            <div className="counter-single counter__anim">
              <div className="inner">
                <h2 className="title">
                  <span className="counter">150</span>+
                </h2>
                <p>
                  Empowered <br />
                  Clients
                </p>
              </div>
            </div>
            <div className="counter-single counter__anim">
              <div className="inner">
                <h2 className="title">
                  <span className="counter">873</span>+
                </h2>
                <p>
                  Cutting-edge <br />
                  Solutions
                </p>
              </div>
            </div>
            <div className="counter-single counter__anim">
              <div className="inner">
                <h2 className="title">
                  <span className="counter">12</span>+
                </h2>
                <p>
                  YEARS OF <br />
                  EXPERIENCE
                </p>
              </div>
            </div>
            <div className="counter-single counter__anim">
              <div className="inner">
                <h2 className="title">
                  <span className="counter">100</span>%
                </h2>
                <p>
                  Job Success Score <br/>on Upwrok
                </p>
              </div>
            </div>

            <div className="counter-single counter__anim">
              <div className="inner">
                <h2 className="title">
                  <span className="counter">20</span>+
                </h2>
                <p>
                  Talented <br/>Team Members
                </p>
              </div>
            </div>

          </div>
          {/* cunter up main wrapper end */}
        </div>
      </div>
    </div>
  </div>
  {/* large-image sections end */}


{/* ==== Service Section start ==== */}
  <ServiceSection />
{/* ==== / Service Section end ==== */}  


{/* ==== GetInTouch Section start ==== */}
<GetInTouch />
{/* ==== / GetInTouch Section end ==== */}  

{/* ==== GetInTouch Section start ==== */}
<TestimonialSection />
{/* ==== / GetInTouch Section end ==== */}  

</>


  );
};

export default Home;
